<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Орг.-прав. форма (ОКОПФ)</div>
            <div class="dx-field-value">
                <ai-text-box-dictionary :value="data.kod_fs" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import AiTextBoxDictionary from '@/components/ai-text-box-dictionary.vue';

const data = inject('serverData');
</script>
